import { JourneyRoute } from '@cash-web/shared-journey-util-main'

import { savingsNuxOrHomeLoader } from './savingsNuxOrHomeLoader'

/**
 * Savings client routes are in a separate library from account-savings-feature-main.
 *
 * Why not in feature-main?
 * - account-shell lazy-loads SavingsContainer from feature-main
 * - account-shell also needs to statically import these routes for JourneyProvider
 * - NX module boundaries forbid static imports of lazy-loaded libraries
 * - This separate library allows static route imports while feature-main stays lazy-loaded
 */
export const savingsClientRoutes = [
  {
    id: 'savings-transfer-in',
    trackingName: 'Savings Transfer In',
    path: 'web/view/savings/transfer-cash/to-savings/:transferContext',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsTransferIn,
    }),
  },
  {
    id: 'savings-transfer-in-goal',
    trackingName: 'Savings Transfer In From Goal',
    path: 'web/view/savings/transfer-cash/to-savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsTransferInFromGoal,
    }),
  },
  {
    id: 'savings-transfer-out',
    trackingName: 'Savings Transfer Out',
    path: 'web/view/savings/transfer-cash/from-savings/:transferContext',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsTransferOut,
    }),
  },
  {
    id: 'savings-transfer-out-goal',
    trackingName: 'Savings Transfer In From Goal',
    path: 'web/view/savings/transfer-cash/from-savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsTransferOutFromGoal,
    }),
  },
  {
    id: 'savings-folder-default',
    trackingName: 'Default Savings Folder',
    path: 'web/view/savings/folder/default',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsDefaultFolder,
    }),
  },
  {
    id: 'savings-folder-goal',
    trackingName: 'Default Savings Folder Goal',
    path: 'dl/view/savings/goal/:goalToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsGoalFolder,
    }),
  },
  {
    id: 'savings-activity',
    trackingName: 'Savings Activity',
    path: 'web/view/savings/activity',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsActivity,
    }),
  },
  {
    id: 'savings-activity-filtered',
    trackingName: 'Savings Activity Filtered',
    path: 'web/view/savings/activity/:subToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsActivity,
    }),
  },
  {
    id: 'savings-interest',
    trackingName: 'Savings Interest',
    path: 'web/view/savings/interest',
    lazy: async () => ({
      Component: (await import('@cash-web/account-savings-feature-main')).JourneySavingsInterest,
    }),
  },
  {
    id: 'savings-view-nux-or-home',
    trackingName: 'Savings View Nux Or Home',
    path: 'dl/view/savings/nux_or_home',
    loader: savingsNuxOrHomeLoader,
  },
  {
    id: 'savings-view-home',
    trackingName: 'Savings View Home',
    path: 'dl/view/savings/home',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/savings')
    },
  },
  {
    id: 'savings-view-with-modal-half-sheet',
    trackingName: 'View Savings Home With Modal Half Sheet',
    path: 'dl/view/savings_with_modal_half_sheet',
    handle: {
      unsupported: true,
    },
  },
] as const satisfies JourneyRoute[]
